@if (isVisible()) {
    <div
        class="quick-bet-container"
        [ngClass]="{
            'bet-builder-quick-bet-confirmation': successState(),
            'in-overlay': inOverlay(),
        }"
        (vnObserveSize)="sizeChanged($event)">
        <bs-quick-deposit-message></bs-quick-deposit-message>
        @if (canShowRewardTokensOnboarding()) {
            <bs-reward-tokens-onboarding-container></bs-reward-tokens-onboarding-container>
        }
        @if (isHelpVisible()) {
            <bs-quick-bet-help></bs-quick-bet-help>
        }
        @if (loadingState() || (placeState() && !shouldRenderQuickBet())) {
            <bs-quick-bet-skeleton></bs-quick-bet-skeleton>
        }

        @if (placeState()) {
            <div [ngClass]="{ 'quick-bet-container-hidden': !shouldRenderQuickBet() }">
                <bs-quick-bet [oddsDisplayFormat]="oddsDisplayFormat"></bs-quick-bet>
            </div>
        }
        @if (successState()) {
            <bs-quick-bet-confirmation-container [oddsDisplayFormat]="oddsDisplayFormat"></bs-quick-bet-confirmation-container>
        }
    </div>
}
